import React from "react";
import { Edit } from "@mui/icons-material";

import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

interface ModificationsPanelProps {
  readOnly?: boolean;
  mode: "inLeadIns" | "inUnderground";
}

const ModificationsPanel: React.FC<ModificationsPanelProps> = ({ mode, readOnly }) => {
  const { open } = useStackedNavigationContext();

  const handleOnEdit = () => () => {
    open(`modification-${mode}`);
  };

  return (
    <>
      {mode === "inLeadIns" && <StackedNavigationButton icon={<Edit />} title="Edit Lead-Ins" onClick={handleOnEdit()} />}
      {mode === "inUnderground" && <StackedNavigationButton icon={<Edit />} title="Edit Underground" onClick={handleOnEdit()} />}
    </>
  );
};

export default ModificationsPanel;
